<ion-content class="content">
  <div class="sticky-header">
    <h1 class="title">
      <span class="sis">Sis</span><span class="maps">Maps</span>
      <span class="interactive-maps"> - {{'sismap.reference.term.title' | translate }}</span>
    </h1>
    <ion-searchbar
      #searchbar
      mode="md"
      class="searchbar sis-sismap-reference-searchbar"
      [debounce]="0"
      [placeholder]="'sismap.reference.term.searchbar' | translate"
      (ionInput)="filterList($event)"
    ></ion-searchbar>
  </div>

  <div class="scroll-container">
    <ion-list class="map-list" lines="none">
      @for (map of filteredMaps; track map) {
        <ion-item class="sis-map-item" (click)="openLink(map)">
          <ion-thumbnail slot="start">
            <img [src]="getBlobUrl(map)" alt="Img" />
          </ion-thumbnail>
          <ion-label>
            <h2>{{ map.tenant }}</h2>
            <p>
              <a>{{ map.name }}</a>
            </p>
          </ion-label>
          <ion-label slot="end" class="season-icons" [matTooltip]="getSeasonText(map) | translate">
            @if (map.season === 0 || map.season === 1) {
              <img
                class="summer-icon"
                [src]="environment.baseUrlPublicAssets + '/sismap/custom-icons/summer.svg'"
                alt="Sommer"
                />
            }
            @if (map.season === 0 || map.season === 2) {
              <img
                class="winter-icon"
                [src]="environment.baseUrlPublicAssets + '/sismap/custom-icons/winter.svg'"
                alt="Winter"
                />
            }
          </ion-label>
        </ion-item>
      }
    </ion-list>
  </div>
</ion-content>

<ion-footer class="footer" mode="md">
  <ion-toolbar class="footer-toolbar">
    <ion-title class="footer-text">
      <img class="footer-logo" src="assets/sis-logo/siscontrol-color.svg" alt="SisControl Logo" />
      &nbsp;| <a href="https://www.sisag.ch" target="_blank">sisag.ch</a> | © 2026 SISAG AG
    </ion-title>
  </ion-toolbar>
</ion-footer>
